import { Pencil, Trash2, CheckCircle2, XCircle } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge, EmptyState, fmtDate, btnGhost, btnDanger } from "@/components/portal/ui";

export default function VisitsTable({ visits, role = "admin", onEdit, onDelete, onStatus, compact = false, emptyTitle = "Nessuna visita", emptyDesc }) {
  if (!visits.length) return <EmptyState title={emptyTitle} desc={emptyDesc} testid="visits-empty" />;

  return (
    <div className="overflow-x-auto rounded-3xl bg-white ring-1 ring-[#5B2C91]/8" data-testid="visits-table">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="whitespace-nowrap">Data</TableHead>
            <TableHead>Ora</TableHead>
            <TableHead>Paziente</TableHead>
            <TableHead>Specialità</TableHead>
            {role !== "doctor" && <TableHead>Medico</TableHead>}
            {role !== "nurse" && !compact && <TableHead>Infermiere</TableHead>}
            <TableHead>Stato</TableHead>
            {(onEdit || onDelete || onStatus) && <TableHead className="text-right">Azioni</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {visits.map((v) => (
            <TableRow key={v.id} data-testid={`visit-row-${v.id}`}>
              <TableCell className="whitespace-nowrap font-semibold capitalize">{fmtDate(v.date)}</TableCell>
              <TableCell className="whitespace-nowrap">{v.start_time}–{v.end_time}</TableCell>
              <TableCell>
                <p className="font-semibold">{v.patient_name}</p>
                {v.patient_phone && <p className="text-xs text-[#6B6280]">{v.patient_phone}</p>}
                {!compact && v.patient_address && <p className="text-xs text-[#8A809A]">{v.patient_address}</p>}
              </TableCell>
              <TableCell>{v.specialty_name}</TableCell>
              {role !== "doctor" && <TableCell className="whitespace-nowrap">{v.doctor_name}</TableCell>}
              {role !== "nurse" && !compact && <TableCell className="whitespace-nowrap">{v.nurse_name || <span className="text-[#8A809A]">—</span>}</TableCell>}
              <TableCell><StatusBadge status={v.status} testid={`visit-status-${v.id}`} /></TableCell>
              {(onEdit || onDelete || onStatus) && (
                <TableCell>
                  <div className="flex items-center justify-end gap-1">
                    {onStatus && v.status === "requested" && (
                      <button onClick={() => onStatus(v, "confirmed")} className={btnGhost} data-testid={`visit-confirm-${v.id}`}>
                        <CheckCircle2 className="h-3.5 w-3.5" /> Conferma
                      </button>
                    )}
                    {onStatus && v.status === "confirmed" && (
                      <button onClick={() => onStatus(v, "completed")} className={btnGhost} data-testid={`visit-complete-${v.id}`}>
                        <CheckCircle2 className="h-3.5 w-3.5" /> Completata
                      </button>
                    )}
                    {onStatus && (v.status === "requested" || v.status === "confirmed") && role === "admin" && (
                      <button onClick={() => onStatus(v, "cancelled")} className={btnDanger} data-testid={`visit-cancel-${v.id}`}>
                        <XCircle className="h-3.5 w-3.5" /> Annulla
                      </button>
                    )}
                    {onEdit && (
                      <button onClick={() => onEdit(v)} className={btnGhost} aria-label="Modifica" data-testid={`visit-edit-${v.id}`}>
                        <Pencil className="h-3.5 w-3.5" />
                      </button>
                    )}
                    {onDelete && (
                      <button onClick={() => onDelete(v)} className={btnDanger} aria-label="Elimina" data-testid={`visit-delete-${v.id}`}>
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    )}
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
